//import libraries
import { Injectable } from '@angular/core';
// import { Http, Headers, RequestOptions, URLSearchParams, Response, ResponseOptions} from '@angular/http';

import { Observable } from 'rxjs';

import { Resolve } from '@angular/router';
import { HttpClient, HttpHeaders } from "@angular/common/http";

//import constants
import { AppSettings } from '../constants/app-settings';
import { AppBackRoutes } from '../constants/app-back-routes';

import  { TreatmentRegisterLang } from "../languages/Privacy.Lang"

@Injectable()

export class PrivacyService implements Resolve<Observable<any>>{

    constructor(
        private http: HttpClient,
    ) { }
    

    resolve() {
        return this.fetchTreatmentRegister();
    }

    fetchTreatmentRegister(): Observable<any> {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.GetAllTreatmentList;
        return this.http.get<any>(url);
    }

    fetchSingleTreatmentRegister(id): Observable<any> {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.GetTreatmentList+"/"+id;
        return this.http.get<any>(url);
    }    

    addTreatmentRegister(data){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.AddTreatmentRegister;
        return this.http.post<any>(url, data);
    }

    treatmentRegisterList(details: any) {
        if (!details) return;
        let instance = new TreatmentRegisterLang(details.data.language);
        return instance.lang();
    }    

    deleteTreatmentCreation(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.DeleteTreatmentRegister;
        return this.http.post<any>(url, data);
    }

    editTreatmentCreation(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.AddTreatmentRegister;
        return this.http.post<any>(url, data);
    }    

}